import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = {
    key: 0,
    class: "form-details"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tNotifications\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = {
    key: 0,
    class: "x_title x-header"
};
const _hoisted_6 = { class: "clearfix tile_count tile-emails-count row" };
const _hoisted_7 = { class: "col-xl tile_stats_count unknown" };
const _hoisted_8 = ["title"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calculator" }),
    /*#__PURE__*/ _createTextVNode(" Emails sent last 24 hours\r\n\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_10 = { class: "count clearfix" };
const _hoisted_11 = { class: "col-xl tile_stats_count unknown" };
const _hoisted_12 = ["title"];
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calculator" }),
    /*#__PURE__*/ _createTextVNode(" SMSs sent last 24 hours\r\n\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_14 = { class: "count clearfix" };
const _hoisted_15 = { class: "col-xl tile_stats_count healthy" };
const _hoisted_16 = { class: "clearfix" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }),
    /*#__PURE__*/ _createTextVNode(" Last summary email\r\n\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_18 = { class: "count clearfix" };
const _hoisted_19 = { class: "col-xl tile_stats_count critical" };
const _hoisted_20 = { class: "clearfix" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }),
    /*#__PURE__*/ _createTextVNode(" Last alarm email\r\n\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_22 = { class: "count clearfix" };
const _hoisted_23 = { class: "col-xl tile_stats_count critical" };
const _hoisted_24 = { class: "clearfix" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }),
    /*#__PURE__*/ _createTextVNode(" Last alarm SMS\r\n\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_26 = { class: "count clearfix" };
const _hoisted_27 = { class: "clearfix" };
const _hoisted_28 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_29 = { class: "input-group top_search" };
const _hoisted_30 = { class: "input-group-btn" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_32 = [
    _hoisted_31
];
const _hoisted_33 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_34 = { class: "input-group top_search" };
const _hoisted_35 = { class: "col-xs-12 col-sm-12 col-md-2" };
const _hoisted_36 = { class: "input-group top_search" };
const _hoisted_37 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_38 = {
    key: 0,
    class: "btn-group pw100"
};
const _hoisted_39 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_40 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_42 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, null, -1 /* HOISTED */);
const _hoisted_45 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_46 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_47 = { class: "float-end" };
const _hoisted_48 = { class: "float-end hidden-xs record-count" };
const _hoisted_49 = { class: "col-xs-12 col-sm-12" };
const _hoisted_50 = { class: "card bg-white data-grid notifications-grid detached overflow-x-auto" };
const _hoisted_51 = {
    id: "notificationsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_52 = { class: "max-width300" };
const _hoisted_53 = { class: "hidden-sm" };
const _hoisted_54 = { class: "hidden-sm" };
const _hoisted_55 = { class: "hidden-sm" };
const _hoisted_56 = { class: "hidden-sm" };
const _hoisted_57 = { class: "hidden-sm text-center" };
const _hoisted_58 = ["onClick"];
const _hoisted_59 = { class: "hidden-sm" };
const _hoisted_60 = { class: "clearfix visible-sm" };
const _hoisted_61 = { class: "blue lead" };
const _hoisted_62 = { class: "clearfix" };
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* HOISTED */);
const _hoisted_64 = { class: "clearfix" };
const _hoisted_65 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-paper-plane" }, null, -1 /* HOISTED */);
const _hoisted_66 = { class: "hidden-sm" };
const _hoisted_67 = { class: "hidden-sm" };
const _hoisted_68 = { class: "hidden-sm" };
const _hoisted_69 = { class: "hidden-sm" };
const _hoisted_70 = { class: "hidden-sm text-center" };
const _hoisted_71 = {
    key: 0,
    class: "fa fa-check green",
    "aria-hidden": "true"
};
const _hoisted_72 = {
    key: 1,
    class: "fa fa-times red",
    "aria-hidden": "true"
};
const _hoisted_73 = { key: 0 };
const _hoisted_74 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center hidden-sm",
    colspan: "5"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_75 = /*#__PURE__*/ _createElementVNode("td", { class: "text-center visible-sm" }, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_76 = { class: "clearfix" };
const _hoisted_77 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_78 = { class: "notification-subject" };
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* HOISTED */);
const _hoisted_80 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-paper-plane" }, null, -1 /* HOISTED */);
const _hoisted_81 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_82 = ["srcdoc"];
const _hoisted_83 = {
    key: 1,
    class: "notification-content"
};
const _hoisted_84 = { class: "float-end float-start-sm" };
const _hoisted_85 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    const _directive_cloud_only = _resolveDirective("cloud-only");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("v-if", true),
        _createTextVNode(),
        _createElementVNode("div", {
            class: _normalizeClass({ 'form-contents': !_ctx.showSummary })
        }, [
            (_ctx.showSummary && _ctx.query.companyId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _withDirectives((_openBlock(), _createElementBlock("div", {
                                title: 'Daily limit: ' + _ctx.summary.notificationPreferences.maxDailyAlarmEmailLimitPerSystem
                            }, [
                                _hoisted_9,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.numberOfEmailsSentToday), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_8)), [
                                [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                ]
                            ])
                        ]),
                        _createTextVNode(),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _withDirectives((_openBlock(), _createElementBlock("div", {
                                title: 'Daily limit: ' + _ctx.summary.notificationPreferences.maxDailyAlarmSmsLimitPerSystem
                            }, [
                                _hoisted_13,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.numberOfSmsSentToday), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_12)), [
                                [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                ]
                            ])
                        ])), [
                            [_directive_cloud_only]
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.whenLastSystemSummaryEmailCreated), 1 /* TEXT */)
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.whenLastAlarmEmailCreated), 1 /* TEXT */)
                            ])
                        ]),
                        _createTextVNode(),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                                _hoisted_25,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.whenLastAlarmSmsCreated), 1 /* TEXT */)
                            ])
                        ])), [
                            [_directive_cloud_only]
                        ])
                    ])
                ]))
                : _createCommentVNode("v-if", true),
            _createTextVNode(),
            _createElementVNode("div", {
                class: _normalizeClass({ 'row': !_ctx.showSummary, 'x_content': _ctx.showSummary })
            }, [
                _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_30, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, _hoisted_32)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.selectedCompanyId,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                                options: _ctx.companies,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "All company",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_35, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.selectedChannelId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.selectedChannelId) = $event)),
                                options: _ctx.channels,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "All types",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])), [
                            [_directive_cloud_only]
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_37, [
                        (!_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                    return (_openBlock(), _createBlock(_component_b_button, {
                                        class: "pw100",
                                        disabled: _ctx.working,
                                        key: idx,
                                        variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                        onClick: ($event) => (_ctx.setDateFilterOption(item))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.query.whenCreatedFrom,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.whenCreatedFrom) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "From date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                                default: _withCtx(() => [
                                                    _hoisted_41
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_42, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.query.whenCreatedTo,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.whenCreatedTo) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "Until date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                                default: _withCtx(() => [
                                                    _hoisted_43,
                                                    _createTextVNode(),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn btn-secondary",
                                                        onClick: _cache[6] || (_cache[6] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                    }, "\r\n\t\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createTextVNode(),
                _hoisted_44,
                _createTextVNode(),
                (_ctx.searchAttempted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                                _createVNode(_component_b_pagination, {
                                    class: "float-end",
                                    modelValue: _ctx.query.pageNo,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.query.pageNo) = $event)),
                                    "per-page": _ctx.query.pageSize,
                                    "total-rows": _ctx.data.recordCount,
                                    "hide-ellipsis": true,
                                    disabled: _ctx.working
                                }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_48, "\r\n\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("table", _hoisted_51, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_52, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'whenAttempted', title: 'Time', visible: true }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", _hoisted_53, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'Subject', title: 'Subject' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", _hoisted_54, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'ContactName', title: 'Contact Name' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", _hoisted_55, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'DestinationAddress', title: 'To' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", _hoisted_56, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'NotificationChannelName', title: 'Type' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("th", _hoisted_57, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'IsSuccessful', title: 'Sucessfully Sent' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: _normalizeClass(['alarm pointer', _ctx.alarmClass(item)]),
                                        onClick: ($event) => (_ctx.view(item))
                                    }, [
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.whenAttemptedTimeString(item)), 1 /* TEXT */),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_60, [
                                                _createElementVNode("span", _hoisted_61, _toDisplayString(item.subject), 1 /* TEXT */),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_62, [
                                                    _hoisted_63,
                                                    _createTextVNode(" " + _toDisplayString(_ctx.whenAttemptedTimeString(item)), 1 /* TEXT */)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_64, [
                                                    _hoisted_65,
                                                    _createTextVNode(" " + _toDisplayString(item.destinationAddress), 1 /* TEXT */)
                                                ])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_66, _toDisplayString(item.subject), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_67, _toDisplayString(item.contactName), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_68, _toDisplayString(item.destinationAddress), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_69, _toDisplayString(item.notificationChannelName), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_70, [
                                            (item.isSuccessful)
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_71))
                                                : (_openBlock(), _createElementBlock("i", _hoisted_72))
                                        ])
                                    ], 10 /* CLASS, PROPS */, _hoisted_58));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_73, [
                                        _hoisted_74,
                                        _createTextVNode(),
                                        _hoisted_75
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ], 2 /* CLASS */)
        ], 2 /* CLASS */),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            class: "modal-form-lg",
            id: "notification_popup",
            modelValue: _ctx.viewingNotification,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.viewingNotification) = $event)),
            "header-bg-variant": "normal",
            size: "xl"
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\t\tNotification\r\n\t\t\t")
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_84, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [
                            _hoisted_85,
                            _createTextVNode(" Close\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                                _createElementVNode("h1", _hoisted_78, _toDisplayString(_ctx.notification.subject), 1 /* TEXT */),
                                _createTextVNode(),
                                _createElementVNode("h2", null, [
                                    _hoisted_79,
                                    _createTextVNode("  " + _toDisplayString(_ctx.whenAttemptedTimeString(_ctx.notification)) + " ", 1 /* TEXT */),
                                    _hoisted_80,
                                    _createTextVNode("  " + _toDisplayString(_ctx.notification.destinationAddress), 1 /* TEXT */)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_81, [
                                (_ctx.notification.notificationChannelId == 1)
                                    ? (_openBlock(), _createElementBlock("iframe", {
                                        key: 0,
                                        id: "notiifcation_content",
                                        class: "notification",
                                        srcdoc: _ctx.notification.content,
                                        sandbox: ""
                                    }, null, 8 /* PROPS */, _hoisted_82))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString(_ctx.notification.content), 1 /* TEXT */))
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode()
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.loading,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
